import React from 'react';
import Modal from '../../ui/modal/modal';
import Button from '../../ui/button/button';
import './expirationModal.css';

export default function ExpirationModal({open = false, title = '', body = '', ctaLabel = ''}) {

    const _onClick = React.useCallback(() => {
        window.location.reload()
    });

    return (
        <Modal
            id='expiration'
            title={title}
            role='alertdialog'
            clasName='neo-expiration-modal'
            open={open}
            submitButton={
                <Button className='neo-expiration-modal-cta' label={ctaLabel} onClick={_onClick}/>
            }
        >
            <p>{body}</p>
        </Modal>
    )
}
